import React from 'react';

import AlignStyle from '../AlignStyle/AlignStyle';
import ColorButtons from '../ColorButtons/ColorButtons';
import TextDecorationWithState from '../TextDecoration/TextDecorationWithState';
import TextDecoration from '../TextDecoration/TextDecoration';

const hAlignOptions = [
  {
    name: 'left',
    iconName: 'left',
    iconSize: 'small',
    label: 'left',
  },
  {
    name: 'center',
    iconName: 'center-h',
    iconSize: 'small',
    label: 'center',
  },
  {
    name: 'right',
    iconName: 'right',
    iconSize: 'small',
    label: 'right',
  },
  {
    name: 'justify',
    iconName: 'justify',
    iconSize: 'small',
    label: 'justify',
  },
];

const textDecorationOptions = [
  {
    name: 'fontWeight',
    iconName: 'bold',
    iconSize: 'small',
    label: 'bold',
  },
  {
    name: 'textDecoration',
    iconName: 'underline',
    iconSize: 'small',
    label: 'underline',
  },
  {
    name: 'fontItalic',
    iconName: 'italic',
    iconSize: 'small',
    label: 'italic',
  },
];

const TextStyle = ({ isParagraph }) => {
  return (
    <>
      <AlignStyle propKey='textAlign' options={hAlignOptions} />
      {isParagraph ? (
        <TextDecoration options={textDecorationOptions} />
      ) : (
        <TextDecorationWithState options={textDecorationOptions} />
      )}
      <ColorButtons />
    </>
  );
};
export default TextStyle;
